import {startTransition} from 'react'

import {useMergeMethodContext} from '../contexts/MergeMethodContext'
import {useStackMergeabilityQuery} from '../page-data/loaders/use-stack-mergeability-page-data'
import {useMergeabilityLiveUpdates, type MergeabilityLiveUpdateChannels} from '../hooks/use-mergeability-live-updates'
import {EMPTY_CHANNELS} from './use-mergeability-status'

export function useStackMergeabilityUpdates({
  basePageDataUrl,
  channels,
}: {
  basePageDataUrl: string
  channels: MergeabilityLiveUpdateChannels | null
}) {
  const {mergeMethod} = useMergeMethodContext()
  const {refetch} = useStackMergeabilityQuery({basePageDataUrl, mergeMethod, enabled: false})
  useMergeabilityLiveUpdates({
    channels: channels ?? EMPTY_CHANNELS,
    refetchQuery: () => {
      startTransition(() => {
        refetch()
      })
    },
    throttleTime: 5000,
  })
}
